import { render, staticRenderFns } from "./CompanyDetailView.vue?vue&type=template&id=63fd2bbb"
import script from "./CompanyDetailView.vue?vue&type=script&lang=js"
export * from "./CompanyDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports